/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ComparisonStatus } from './ComparisonStatus';
import {
    ComparisonStatusFromJSON,
    ComparisonStatusFromJSONTyped,
    ComparisonStatusToJSON,
    ComparisonStatusToJSONTyped,
} from './ComparisonStatus';
import type { GetRoomMatchGroupsResponsePagination } from './GetRoomMatchGroupsResponsePagination';
import {
    GetRoomMatchGroupsResponsePaginationFromJSON,
    GetRoomMatchGroupsResponsePaginationFromJSONTyped,
    GetRoomMatchGroupsResponsePaginationToJSON,
    GetRoomMatchGroupsResponsePaginationToJSONTyped,
} from './GetRoomMatchGroupsResponsePagination';
import type { RoomMatchGroup } from './RoomMatchGroup';
import {
    RoomMatchGroupFromJSON,
    RoomMatchGroupFromJSONTyped,
    RoomMatchGroupToJSON,
    RoomMatchGroupToJSONTyped,
} from './RoomMatchGroup';

/**
 * Response containing room match groups for a comparison
 * @export
 * @interface GetRoomMatchGroupsResponse
 */
export interface GetRoomMatchGroupsResponse {
    /**
     * ID of the comparison
     * @type {number}
     * @memberof GetRoomMatchGroupsResponse
     */
    comparisonId: number;
    /**
     * 
     * @type {ComparisonStatus}
     * @memberof GetRoomMatchGroupsResponse
     */
    status: ComparisonStatus;
    /**
     * List of room match groups
     * @type {Array<RoomMatchGroup>}
     * @memberof GetRoomMatchGroupsResponse
     */
    roomMatchGroups: Array<RoomMatchGroup>;
    /**
     * 
     * @type {GetRoomMatchGroupsResponsePagination}
     * @memberof GetRoomMatchGroupsResponse
     */
    pagination: GetRoomMatchGroupsResponsePagination;
}



/**
 * Check if a given object implements the GetRoomMatchGroupsResponse interface.
 */
export function instanceOfGetRoomMatchGroupsResponse(value: object): value is GetRoomMatchGroupsResponse {
    if (!('comparisonId' in value) || value['comparisonId'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('roomMatchGroups' in value) || value['roomMatchGroups'] === undefined) return false;
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    return true;
}

export function GetRoomMatchGroupsResponseFromJSON(json: any): GetRoomMatchGroupsResponse {
    return GetRoomMatchGroupsResponseFromJSONTyped(json, false);
}

export function GetRoomMatchGroupsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetRoomMatchGroupsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'comparisonId': json['comparisonId'],
        'status': ComparisonStatusFromJSON(json['status']),
        'roomMatchGroups': ((json['roomMatchGroups'] as Array<any>).map(RoomMatchGroupFromJSON)),
        'pagination': GetRoomMatchGroupsResponsePaginationFromJSON(json['pagination']),
    };
}

export function GetRoomMatchGroupsResponseToJSON(json: any): GetRoomMatchGroupsResponse {
    return GetRoomMatchGroupsResponseToJSONTyped(json, false);
}

export function GetRoomMatchGroupsResponseToJSONTyped(value?: GetRoomMatchGroupsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'comparisonId': value['comparisonId'],
        'status': ComparisonStatusToJSON(value['status']),
        'roomMatchGroups': ((value['roomMatchGroups'] as Array<any>).map(RoomMatchGroupToJSON)),
        'pagination': GetRoomMatchGroupsResponsePaginationToJSON(value['pagination']),
    };
}

